class DesignerModalForm {
  constructor() {
    this.form = document.getElementById('designer-modal-form');

    if (!this.form) return;

    this.modalWrapper = this.form.closest('.product-main-modal-wrapper-js');
    this.successState = this.modalWrapper?.querySelector('.enquiry-modal__success');
    this.errorMessage = this.modalWrapper?.querySelector('.enquiry-modal__error-message');
    this.continueBtn = this.modalWrapper?.querySelector('.enquiry-modal__continue');
    this.botpoison = null;

    this.init();
  }

  async init() {
    this.continueBtn?.addEventListener('click', () => this.close());

    if (this.form && window.BOTPOISON_PUBLIC_KEY) {
      await this.initializeBotpoison();
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    } else {
      this.form.addEventListener('submit', (event) =>
        this.handleSubmitWithoutBotpoison(event),
      );
    }
  }

  async initializeBotpoison() {
    try {
      await this.waitForBotpoison();
      this.botpoison = new Botpoison({
        publicKey: window.BOTPOISON_PUBLIC_KEY,
      });
    } catch (error) {
      console.error('Designer Botpoison initialization failed:', error);
      this.handleBotpoisonFailure();
    }
  }

  waitForBotpoison() {
    return new Promise((resolve, reject) => {
      if (typeof Botpoison !== 'undefined') {
        resolve();
        return;
      }

      let attempts = 0;
      const maxAttempts = 50;

      const checkBotpoison = () => {
        if (typeof Botpoison !== 'undefined') {
          resolve();
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkBotpoison, 100);
        } else {
          reject(new Error('Botpoison failed to load'));
        }
      };

      checkBotpoison();
    });
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.setLoadingState(true);
    this.hideError();

    try {
      const { solution } = await this.botpoison.challenge();
      const formData = new FormData(this.form);
      const formObject = this.buildFormPayload(formData);
      formObject._botpoison = solution;

      const response = await fetch(this.form.getAttribute('action'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formObject),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      this.showSuccess();
    } catch (error) {
      console.error('Designer form submission error:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleSubmitWithoutBotpoison(event) {
    event.preventDefault();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    this.setLoadingState(true);
    this.hideError();

    try {
      const formData = new FormData(this.form);
      const formObject = this.buildFormPayload(formData);
      const response = await fetch(this.form.getAttribute('action'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(formObject),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      this.showSuccess();
    } catch (error) {
      console.error('Designer form submission error:', error);
      this.showError();
    } finally {
      this.setLoadingState(false);
    }
  }

  buildFormPayload(formData) {
    const formObject = Object.fromEntries(formData.entries());
    const customSelectInputs = this.form.querySelectorAll('.custom-select__input[name]');

    customSelectInputs.forEach((input) => {
      // Keep custom-select values explicit in payload for future field additions.
      formObject[input.name] = input.value || 'N/A';
    });

    return formObject;
  }

  setLoadingState(isLoading) {
    const submitButton = this.form.querySelector('button[type="submit"]');

    if (!submitButton) return;

    if (isLoading) {
      this.form.classList.add('is-loading');
      submitButton.setAttribute('disabled', 'disabled');
    } else {
      this.form.classList.remove('is-loading');
      submitButton.removeAttribute('disabled');
    }
  }

  showSuccess() {
    this.form.style.display = 'none';
    if (this.successState) {
      this.successState.style.display = 'block';
    }

    this.form.dispatchEvent(new CustomEvent('fw:enquiry-success', { bubbles: true }));

    setTimeout(() => {
      this.form.reset();
    }, 1000);
  }

  showError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';
    }
  }

  hideError() {
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  handleBotpoisonFailure() {
    const submitButton = this.form.querySelector('button[type="submit"]');

    if (this.errorMessage) {
      this.errorMessage.textContent =
        'Bot protection service unavailable. Please try again later.';
      this.errorMessage.style.display = 'block';
    }

    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.textContent = 'Service Unavailable';
    }
  }

  close() {
    if (!this.modalWrapper) return;

    const modal = this.modalWrapper.querySelector('.product-info-modal-js');
    const backdrop = this.modalWrapper.querySelector('.product-info-modal-backdrop-js');

    modal?.classList.remove('active');
    backdrop?.classList.remove('active');
    document.body.classList.remove('product-info-modal--open');

    setTimeout(() => {
      this.form.style.display = 'flex';
      this.form.reset();

      if (this.successState) {
        this.successState.style.display = 'none';
      }

      this.hideError();
    }, 500);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new DesignerModalForm();
});
